// How any page opens the chat bubble: the Connections page asks for a connection session, a tile asks for a
// draft. The bubble is mounted once in the shell and listens; nothing else needs a context.

export const AGENT_CHAT_OPEN_EVENT = "growthos:agent-chat-open";

/**
 * Opens the bubble. `seed` = { kind: "connect", app, label, fields } starts a connection session with the masked
 * key field; `draft` prefills the composer; `message` is sent right away as the person's own words.
 */
export function openAgentChat(detail = {}) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(AGENT_CHAT_OPEN_EVENT, { detail }));
}

export function onAgentChatOpen(listener) {
  if (typeof window === "undefined") return () => {};
  const handler = (event) => listener(event.detail || {});
  window.addEventListener(AGENT_CHAT_OPEN_EVENT, handler);
  return () => window.removeEventListener(AGENT_CHAT_OPEN_EVENT, handler);
}

// The bubble tells the page when a connection changed on the agent (a sign-in finished, a key landed), so the
// page can show the card at once and reload. detail = { app, label?, kind?, toolCount? }.
export const CONNECTIONS_CHANGED_EVENT = "growthos:connections-changed";

export function announceConnectionsChanged(detail = {}) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(CONNECTIONS_CHANGED_EVENT, { detail }));
}

export function onConnectionsChanged(listener) {
  if (typeof window === "undefined") return () => {};
  const handler = (event) => listener(event.detail || {});
  window.addEventListener(CONNECTIONS_CHANGED_EVENT, handler);
  return () => window.removeEventListener(CONNECTIONS_CHANGED_EVENT, handler);
}

/** Opens a provider in a small window; null when the browser refused (the caller then offers a plain link). */
export function openPopup(url, name = "growthos-connect") {
  try {
    const popup = window.open(url, name, "popup,width=520,height=720,noopener");
    return popup || null;
  } catch {
    return null;
  }
}
